<div style="position: relative; top: 0; left: 1%;width: 97%;">
  <div class="d-flex justify-content-between">
    <span class="d-inline-block">
      <h2 class="mb-0">{{company?.company_name}}</h2>
      @if (company?.tax_id) {
        <div class="text-muted fs-5 mb-3">{{company?.tax_id}}</div>
      }
    </span>
    @if (user?.roles.includes('ADMIN')) {
      <span class="btn-group-sm p-1">
        <button class="btn btn-outline-primary" (click)="editForm.show()"
          title="{{'COMPANY.UPDATE_TITLE' | translate}}" aria-label="{{'COMPANY.UPDATE_TITLE' | translate}}">
          <lucide-icon name="square-pen" size="16"></lucide-icon>
        </button>
      </span>
    }
  </div>
  <div class="col-xs-12">
    <nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
      <ng-container [ngbNavItem]="1">
        <a ngbNavLink>{{'COMPANY.TAB_INFO' | translate}}</a>
        <ng-template ngbNavContent>
          <div [hidden]="submitted">
            <ol class="list-group list-group-flush">
              @if (company.company_name) {
                <li class="list-group-item list-group-item-action d-flex justify-content-around mt-3">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{'COMPANY.NAME' | translate}}</div>
                  </div>
                  <span class="badge text-bg-light rounded-pill text-uppercase">{{company.company_name}}</span>
                </li>
              }
              @if (company.tax_id) {
                <li class="list-group-item list-group-item-action d-flex justify-content-around mt-3">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{'COMPANY.TAXID' | translate}}</div>
                  </div>
                  <span class="badge text-bg-light rounded-pill text-uppercase">{{company.tax_id}}</span>
                </li>
              }
              @if (company.first_name) {
                <li class="list-group-item list-group-item-action d-flex justify-content-around mt-3">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{'COMPANY.FIRSTNAME' | translate}}</div>
                  </div>
                  <span class="badge text-bg-light text-uppercase">{{company.first_name}}</span>
                </li>
              }
              @if (company.last_name) {
                <li class="list-group-item list-group-item-action d-flex justify-content-around mt-3">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">{{'COMPANY.LASTNAME' | translate}}</div>
                  </div>
                  <span class="badge text-bg-light rounded-pill text-uppercase">{{company.last_name}}</span>
                </li>
              }
              @for (property of company?.properties | keyvalue; track property) {
                <li class="list-group-item list-group-item-action d-flex justify-content-around mt-3">
                  <div class="ms-2 me-auto">
                    <div class="h6 text-danger">{{property.key}}</div>
                  </div>
                  <span class="badge text-bg-light rounded-pill text-uppercase">{{property.value}}</span>
                </li>
              }
            </ol>
          </div>
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="2">
        <a ngbNavLink>{{'COMPANY.TAB_DATASETS' | translate}}</a>
        <ng-template ngbNavContent>
          <div class="mt-2">
            <div class="btn-group flex-wrap" role="group" aria-label="Basic radio toggle button group">
              @for (dataset of datasets; track dataset) {
                <button type="button"
                  class="btn btn-outline-primary"
                  [class.active]="loadingDatasetId === null && selectedDatasetId === dataset.file_format_id"
                  [disabled]="loadingDatasetId !== null"
                  (click)="loadFormat(dataset._id, dataset.file_format_id)">
                  @if (loadingDatasetId === dataset.file_format_id) {
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  }
                  {{dataset.service_name}}/{{dataset.file_format_name}}
                </button>
              }
            </div>

            @if (startLoading) {
              <div class="loader center"></div>
            }
            @if (!startLoading && !data) {
              <div class="text-muted mt-3 ms-1">Select a dataset above to view data.</div>
            }
            @if (startLoading==false && data) {
              <div>
                <ntr-datatable [metaInfo]="metaInfo" [data]="data" [disableHeader]="false"
                  [actionButtons]="false" (onQuery)="onGridQuery($event)" [columns]="columns"
                  [headers]="['','Name','Code','Type']">
                </ntr-datatable>
              </div>
            }
          </div>
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="3">
        <a ngbNavLink>{{'COMPANY.TAB_DOCUMENTS' | translate}}</a>
        <ng-template ngbNavContent>
          <div class="mt-2">
            <button class="btn btn-outline-primary" (click)="addDocument.show()">
              <lucide-icon name="cloud-upload" size="16"></lucide-icon>
              Add new document
            </button>
          </div>
          <div class="mt-3">
            <ol class="list-group list-group-flush">
              @for (document of documents; track document) {
                <li class="list-group-item list-group-item-action mt-3">
                  <div class="d-flex justify-content-between">
                    <div class="me-auto align-self-center">
                      <div class="fw-bold">{{ document.originalname }}</div>
                    </div>
                    <div class="me-auto align-self-center">
                      <span class="">{{ document.upload_date | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="me-auto align-self-center ">
                      <button class="btn btn-sm btn-outline-primary"
                        (click)="downloadDocument(document)">
                        <lucide-icon name="cloud-download" size="16"></lucide-icon>
                      </button>
                      <button class="btn btn-sm btn-outline-danger"
                        (click)="deleteDocument(document.id)">
                        <lucide-icon name="trash-2" size="16"></lucide-icon>
                      </button>
                    </div>
                  </div>
                </li>
              }
            </ol>
          </div>
        </ng-template>
      </ng-container>

      <!--
        The CERBERE tab. Hidden entirely when an administrator has switched the
        control module off in Settings -- the taxpayer profile is used by
        deployments that do not run controls at all, and an empty tab labelled
        with a module they do not have is worse than no tab.
      -->
      @if (controlsModuleEnabled) {
        <ng-container [ngbNavItem]="4">
          <a ngbNavLink>{{'COMPANY.TAB_CONTROLS' | translate}}</a>
          <ng-template ngbNavContent>
            <div class="row mt-2">
              <div class="col-auto mt-4 ms-0">
                <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-2"
                  (click)="newProcess(template)">
                  <lucide-icon name="plus" size="16"></lucide-icon>
                  <span>{{'CONTROL-MODULE.CREATE_PRESELECTION' | translate}}</span>
                </button>
              </div>
            </div>
            @if (controlsData) {
              <div class="card mt-4">
                <div class="card-header">
                  <h5 class="mb-0">All Controls</h5>
                </div>
                <div class="card-body">
                  <ntr-datatable [data]="controlsData" [columns]="controlsColumns"
                    [metaInfo]="controlsMetaInfo" [disableHeader]="true" [actionButtons]="false"
                    [pageSize]="maxSize" [hideSinglePagePager]="true"
                    (onQuery)="onControlsQuery($event)">
                  </ntr-datatable>
                </div>
              </div>
            }
            @if (processes) {
              <div class="card mt-4">
                <div class="card-header">
                  <h5 class="mb-0">My Controls</h5>
                </div>
                <div class="card-body">
                  @if (totalCount > maxSize) {
                    <div class="row ms-0">
                      <ngb-pagination class="d-flex justify-content-center"
                        [maxSize]="10"
                        [pageSize]="maxSize"
                        [boundaryLinks]="true"
                        [collectionSize]="totalCount" [(page)]="numPages" (pageChange)="changePage($event)">
                      </ngb-pagination>
                    </div>
                  }
                  <div class="row">
                    @for (process of processes; track process) {
                      <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mb-4 mt-4">
                        <app-process-card [process]="process" [onlyProg]="true"
                          [companyId]="this.company.id">
                        </app-process-card>
                      </div>
                    }
                    @if (processes.length === 0) {
                      <div class="col-12 text-center text-muted py-3">
                        {{'DATATABLE.NO_DATA' | translate}}
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <ng-template #template>
              <div class="modal-header">
                <h4 class="modal-title pull-left">{{'CONTROL-MODULE.CREATE_NEW_CONTROL' | translate}}</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close"
                  (click)="modalRef?.hide()">
                  <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <app-new-preprocess [company]="company" [modalRef]="modalRef"></app-new-preprocess>
              </div>
            </ng-template>
          </ng-template>
        </ng-container>
      }
    </nav>
    <div [ngbNavOutlet]="nav" class="mt-0"></div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
</ngx-spinner>

<app-company-form #editForm [company]="company" (saved)="onCompanySaved($event)"></app-company-form>
<app-company-document-upload #addDocument [company]="company" (uploaded)="loadDocuments()"></app-company-document-upload>
<!--<app-file-upload-element #addDocument></app-file-upload-element>-->
